import type { FC } from 'react';
import React, { useEffect } from 'react';
// TODO: https://jira.moscow.alfaintra.net/browse/ALFABANKRU-83779
// eslint-disable-next-line package-imports/no-core-components-imports
import { Badge } from '@alfalab/core-components-badge';
import { InformationCircleMIcon } from '@alfalab/icons-glyph/InformationCircleMIcon';
import cn from 'classnames';
import { Field } from '@alfa-bank/site-form-utils/components/form-field';
import { BlockDesktop as Block } from '@alfa-bank/site-block/desktop';
import { sendEvent } from '@alfa-bank/site-helpers-common/browser/send-event';
import { NamedContainer } from '@alfa-bank/site-named-container';

import type { TNoDeliveryBlock } from '../models';
import styles from '../styles.css';
import { deliveryStepAnalytics as analytics } from '../../../../../analytics';

export const NoDeliveryBlock: FC<TNoDeliveryBlock> = ({ Plate, alertText, className }) => {
    useEffect(() => {
        sendEvent(analytics.deliveryMethod.incorrect);
    }, []);

    return (
        <>
            <Block className={className} dataTestId="dc-form-delivery-alert" notPadded>
                <Plate hasCloser={false} view="attention">
                    <NamedContainer name="leftAddons">
                        <Badge
                            className={cn(styles.external, styles.badge)}
                            content={<InformationCircleMIcon />}
                            iconColor="attention"
                            view="icon"
                        />
                    </NamedContainer>
                    {alertText}
                </Plate>
            </Block>
            <Field
                name="invisibleNoDeliveryAlertField"
                render={() => null}
                validate={() => {
                    // Ошибка валидации для невозможности сабмита формы
                    return 'Invisible validation error';
                }}
            />
        </>
    );
};
